/*******************************

 Pages names

 *******************************/


const ABOUT_YOUR_HOUSEHOLD_PAGE = 'ABOUT_YOUR_HOUSEHOLD_PAGE';
const ACTIVE_MILITARY_VETERAN_PAGE = 'ACTIVE_MILITARY_VETERAN_PAGE';
const ADDITIONAL_INFORMATION_SUMMARY_PAGE = 'ADDITIONAL_INFORMATION_SUMMARY_PAGE';
const ADDITIONAL_INFORMATION_PAGE = 'ADDITIONAL_INFORMATION_PAGE';
const APPLICATION_ASSISTANCE_PAGE = 'APPLICATION_ASSISTANCE_PAGE';
const APPLICANTS_PAGE = 'APPLICANTS_PAGE';
const AMERICAN_INDIAN_ALASKA_NATIVE_PAGE = 'AMERICAN_INDIAN_ALASKA_NATIVE_PAGE';
const BEFORE_WE_BEGIN_PAGE = 'BEFORE_WE_BEGIN_PAGE';
const CITIZENSHIP_IMMIGRATION_STATUS_PAGE = 'CITIZENSHIP_IMMIGRATION_STATUS_PAGE';
const DEDUCTION_SOURCES_PAGE = 'DEDUCTION_SOURCES_PAGE';
const DISABILITY_INFORMATION_PAGE =  'DISABILITY_INFORMATION_PAGE';
const EMPLOYER_COVERAGE_DETAIL_PAGE = 'EMPLOYER_COVERAGE_DETAIL_PAGE';
const ETHNICITY_AND_RACE_PAGE = 'ETHNICITY_AND_RACE_PAGE';
const EXPECTED_INCOME_PAGE = 'EXPECTED_INCOME_PAGE';
const EXTRA_FINAL_APPLICATION_REVIEW_PAGE = 'EXTRA_FINAL_APPLICATION_REVIEW_PAGE';
const FAMILY_AND_HOUSEHOLD_SUMMARY_PAGE = 'FAMILY_AND_HOUSEHOLD_SUMMARY_PAGE';
const FINAL_APPLICATION_REVIEW_PAGE = 'FINAL_APPLICATION_REVIEW_PAGE';
const FOSTER_CARE_INFORMATION_PAGE = 'FOSTER_CARE_INFORMATION_PAGE';
const FULL_TIME_STUDENT_PAGE = 'FULL_TIME_STUDENT_PAGE';
const GET_READY_FOR_HOUSEHOLD_AND_FAMILY_PAGE = 'GET_READY_FOR_HOUSEHOLD_AND_FAMILY_PAGE';
const GET_READY_FOR_INCOME_PAGE = 'GET_READY_FOR_INCOME_PAGE';
const GET_READY_PAGE = 'GET_READY_PAGE';
const HEALTH_REIMBURSEMENT_ARRANGEMENT_DETAIL_PAGE = 'HEALTH_REIMBURSEMENT_ARRANGEMENT_DETAIL_PAGE';
const HELP_PAYING_FOR_COVERAGE_PAGE = 'HELP_PAYING_F0R_COVERAGE_PAGE';
const HOUSEHOLD_SUMMARY_PAGE = 'HOUSEHOLD_SUMMARY_PAGE';
const INCOME_DISCREPANCY_PAGE = 'INCOME_DISCREPANCY_PAGE';
const INCOME_INFORMATION_SUMMARY_PAGE = 'INCOME_INFORMATION_SUMMARY_PAGE';
const INCOME_SOURCES_PAGE = 'INCOME_SOURCES_PAGE';
const MARITAL_STATUS = 'MARITAL_STATUS';
const MEDICAID_CHIP_DENIAL_INFORMATION_PAGE = 'MEDICAID_CHIP_DENIAL_INFORMATION_PAGE';
const MEDICAID_TERMINATION_DETAILS_PAGE = 'MEDICAID_TERMINATION_DETAILS_PAGE';
const MEDICAL_EMERGENCY_STATUS_PAGE = 'MEDICAL_EMERGENCY_STATUS_PAGE';
const OTHER_ADDRESSES_PAGE = 'OTHER_ADDRESSES_PAGE';
const OTHER_HEALTH_COVERAGE_PAGE = 'OTHER_HEALTH_COVERAGE_PAGE';
const PARENT_CARETAKER_INFORMATION_PAGE = 'PARENT_CARETAKER_INFORMATION_PAGE';
const PERSONAL_INCOME_SUMMARY_PAGE = 'PERSONAL_INCOME_SUMMARY_PAGE';
const PERSONAL_INFORMATION_PAGE = 'PERSONAL_INFORMATION_PAGE';
const PREGNANCY_INFORMATION_PAGE = 'PREGNANCY_INFORMATION_PAGE';
const PRIMARY_CONTACT_INFORMATION_PAGE = 'PRIMARY_CONTACT_INFORMATION_PAGE';
const RECONCILIATION_IN_APTC_PAGE = 'RECONCILIATION_IN_APTC_PAGE';
const RELATIONSHIPS_PAGE = 'RELATIONSHIPS_PAGE';
const RESIDENCY_INFORMATION_PAGE = 'RESIDENCY_INFORMATION_PAGE';
const REVIEW_AND_SIGN_PAGE = 'REVIEW_AND_SIGN_PAGE';
const SIGN_AND_SUBMIT_PAGE = 'SIGN_AND_SUBMIT_PAGE';
const STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE = 'STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE';
const TAX_HOUSEHOLD_COMPOSITION_PAGE = 'TAX_HOUSEHOLD_COMPOSITION_PAGE';
const TRIBAL_SOURCE_INCOME_PAGE = 'TRIBAL_SOURCE_INCOME_PAGE';


export const PAGES = {
    ABOUT_YOUR_HOUSEHOLD_PAGE,
    ACTIVE_MILITARY_VETERAN_PAGE,
    ADDITIONAL_INFORMATION_SUMMARY_PAGE,
    ADDITIONAL_INFORMATION_PAGE,
    AMERICAN_INDIAN_ALASKA_NATIVE_PAGE,
    APPLICANTS_PAGE,
    APPLICATION_ASSISTANCE_PAGE,
    BEFORE_WE_BEGIN_PAGE,
    CITIZENSHIP_IMMIGRATION_STATUS_PAGE,
    DISABILITY_INFORMATION_PAGE,
    DEDUCTION_SOURCES_PAGE,
    EMPLOYER_COVERAGE_DETAIL_PAGE,
    ETHNICITY_AND_RACE_PAGE,
    EXPECTED_INCOME_PAGE,
    EXTRA_FINAL_APPLICATION_REVIEW_PAGE,
    FOSTER_CARE_INFORMATION_PAGE,
    FAMILY_AND_HOUSEHOLD_SUMMARY_PAGE,
    FINAL_APPLICATION_REVIEW_PAGE,
    FULL_TIME_STUDENT_PAGE,
    GET_READY_FOR_HOUSEHOLD_AND_FAMILY_PAGE,
    GET_READY_FOR_INCOME_PAGE,
    GET_READY_PAGE,
    INCOME_DISCREPANCY_PAGE,
    INCOME_INFORMATION_SUMMARY_PAGE,
    INCOME_SOURCES_PAGE,
    HEALTH_REIMBURSEMENT_ARRANGEMENT_DETAIL_PAGE,
    HELP_PAYING_FOR_COVERAGE_PAGE,
    HOUSEHOLD_SUMMARY_PAGE,
    MARITAL_STATUS,
    MEDICAID_CHIP_DENIAL_INFORMATION_PAGE,
    MEDICAID_TERMINATION_DETAILS_PAGE,
    MEDICAL_EMERGENCY_STATUS_PAGE,
    OTHER_ADDRESSES_PAGE,
    OTHER_HEALTH_COVERAGE_PAGE,
    PARENT_CARETAKER_INFORMATION_PAGE,
    PREGNANCY_INFORMATION_PAGE,
    PERSONAL_INCOME_SUMMARY_PAGE,
    PERSONAL_INFORMATION_PAGE,
    PRIMARY_CONTACT_INFORMATION_PAGE,
    RECONCILIATION_IN_APTC_PAGE,
    RELATIONSHIPS_PAGE,
    RESIDENCY_INFORMATION_PAGE,
    REVIEW_AND_SIGN_PAGE,
    SIGN_AND_SUBMIT_PAGE,
    STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE,
    TAX_HOUSEHOLD_COMPOSITION_PAGE,
    TRIBAL_SOURCE_INCOME_PAGE,
};